<template>
  <div class="main">
    <b-row>
      <b-col cols="8">
          <b-row>
            <div id="loangraph"></div>
			<div id="loan_graph_scrollbar" style="direction: rtl;max-height: 20px; overflow: auto; width: 100%;" v-on:mouseup="updateTotalOnBalanceGraphPerScrollBarEvent" v-if=this.displayLoanBalanceScrollBar>
				<div id="loan_scrollbar_child_div" :style=this.onLoanBalanceScrollbarCssStyle />
			</div>
          </b-row>
          <b-row>
            <div id="grossgraph"></div>
			<div id="gross_earnings_graph_scrollbar" style="direction: rtl;max-height: 20px; overflow: auto; width: 100%;" v-on:mouseup="updateGrossEarningsGraphPerScrollBarEvent" v-if=this.displayGrossEarningsScrollBar>
				<div id="earnings_scrollbar_child_div" :style=this.grossEarningsScrollbarCssStyle />
			</div>
          </b-row>
      </b-col>
      <b-col cols="4">
        <div v-loading="loading" >
          <div class="tableDescription"> Program Summary </div>
          <el-table :data="psData" border :header-cell-style="psHeaderStyle">
            <el-table-column prop="label" label="">
              <template slot-scope="slotData">
                <el-tooltip effect="light" placement="bottom" :content="slotData.row.label" :enterable=false :visible-arrow=false :offset=75>
                  <span>{{ slotData.row.label}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="value" label="" align=right>
              <template slot-scope="slotData">
                <el-tooltip effect="light" placement="bottom" :content="slotData.row.value" :enterable=false :visible-arrow=false :offset=75>
                  <span>{{ slotData.row.value}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <br>
        <div v-loading="loading">
          <div class="tableDescription"> Earnings Summary </div>
          <el-table :data="esData" border :header-cell-style="esHeaderStyle">
            <el-table-column v-for="item in esTitles" :key="item.prop" :prop="item.prop" :label="item.label" :align="item.align" :min-width="item.width" header-align="center">
              <template slot-scope="slotData">
                <el-tooltip effect="light" placement="bottom" :content="slotData.row[item.prop]" :enterable=false :visible-arrow=false :offset=75>
                  <span>{{ slotData.row[item.prop]}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import HTTP_API from '@/utils/http-api'
import GRAPHICS_HTTP_API from '@/utils/graphics-http-api'
import * as pieChartUtil from '../utils/PieChartUtility.js';
import * as dataUtil from '../utils/DataUtil.js'
import * as dateUtil from '../utils/DateUtil.js';

export default {
  name: 'Home',
  data () {
    return {
      date: new Date(),
      loading: false,
	  currencyCode: '',
	  lenderId: -1,
	  grossEarningsChartOptions: {},
	  onLoanBalanceChartOptions: {},
	  onLoanBalanceChart: {},
	  onLoanData0: [],
	  onLoanData1: [],
	  onLoanData2: [],
	  grossData0: [],
	  grossData1: [],
	  grossData2: [],
	  grossData3: [],
	  displayGrossEarningsScrollBar: false,
	  displayLoanBalanceScrollBar: false,
	  onLoanBalanceDisplayPercentage: .50,
	  onLoanBalanceScrollbarCssStyle: 'width:714px;height:100px',	  
	  grossEarningsDisplayPercentage: .50,
	  grossEarningsScrollbarCssStyle: 'width:3000px;height:100px',	
	  grossEarningsChartTickInterval: 3600 * 1000 * 24 * 1,  //monthly
	  totalOnLoanTickInterval: 3600 * 1000 * 24 * 1,  //monthly
      psData: [],
      esData: [],
      months: dateUtil.getMonthNames(),
      esTitles: [
        { prop: 'earningsType', label: '', width: '93'},
        { prop: 'earningsAmountStr', label: 'Daily', align: 'right'},
        { prop: 'mtdEarningsAmountStr', label: 'MTD', align: 'right'},
        { prop: 'ytdEarningsAmountStr', label: 'YTD', align: 'right'}
      ],
      startDateString: '',
      endDateString: ''
    }
  },
  methods: {
			updateTotalOnBalanceGraphPerScrollBarEvent(event){				
				var vm = this;

				var currentChart = Object.assign({}, this.onLoanBalanceChart);
				var currentSeries = currentChart.series;

				var localDiscs = vm.onLoanData0;				
				var localExecs = vm.onLoanData1;
				var localTotals = vm.onLoanData2;
				
				currentChart.series = localSeries;
				
				var scrollageIndex = this.processScrollBarData(event);		
				var beginningPercent = scrollageIndex.leftScrollPercent;
				var endingPercent = beginningPercent + this.onLoanBalanceDisplayPercentage;
				
				var yearInMilliseconds = 3600 * 24 * 366 * 1000;
				var nowInMilliseconds = new Date().getTime();
				var yearAgoInMilliseconds = nowInMilliseconds - yearInMilliseconds;
				var startRangeMillis = (yearAgoInMilliseconds) + (yearInMilliseconds * beginningPercent);
				var endRangeMillis = (yearAgoInMilliseconds) + (yearInMilliseconds * endingPercent);
				
				//advisory:
				var msg = "startRangeMillis: |" + (new Date(startRangeMillis)) + "|  endRangeMillis: |" + (new Date(endRangeMillis))+ "| localDiscs.length: |" + localDiscs.length + "|  |" + (new Date(localDiscs[0][0])) + "+";
				
				var filteredDiscs = dataUtil.selectRecordsWithinRangePerDateIndex(localDiscs, 0, startRangeMillis, endRangeMillis);	
				var filteredExecs = dataUtil.selectRecordsWithinRangePerDateIndex(localExecs, 0, startRangeMillis, endRangeMillis);	
				var filteredTotals = dataUtil.selectRecordsWithinRangePerDateIndex(localTotals, 0, startRangeMillis, endRangeMillis);	

				var localSeries = [
					{
						name: 'Total Discretionary',
						data: filteredDiscs
					}, {
						name: 'Total Exclusive',
						data: filteredExecs
					}, {
						name: 'Total On Loan',
						data: filteredTotals
					}
				];

				currentChart.series = localSeries;

				currentChart.xAxis.tickInterval = vm.totalOnLoanTickInterval;

				currentChart.customized.chartName = 'totalOnLoan'

				currentChart.title.text = "Total On Loan"
				
				var Highcharts = require('highcharts');
				Highcharts.chart("loangraph", currentChart);
			},
			updateGrossEarningsGraphPerScrollBarEvent(event){				
				var vm = this;

				var currentChart = Object.assign({}, this.grossEarningsChartOptions);
				var currentSeries = currentChart.series;

				var localDiscs = vm.grossData0;				
				var localExecs = vm.grossData1;
				var localReinvestments = vm.grossData2;
				var localTotals = vm.grossData3;
				
				currentChart.series = localSeries;
				
				var scrollageIndex = this.processScrollBarData(event);		
				var beginningPercent = scrollageIndex.leftScrollPercent;
				var endingPercent = beginningPercent + this.grossEarningsDisplayPercentage;

				var yearInMilliseconds = 3600 * 24 * 366 * 1000;
				var nowInMilliseconds = new Date().getTime();
				var yearAgoInMilliseconds = nowInMilliseconds - yearInMilliseconds;
				var startRangeMillis = (yearAgoInMilliseconds) + (yearInMilliseconds * beginningPercent);
				var endRangeMillis = (yearAgoInMilliseconds) + (yearInMilliseconds * endingPercent);
				
				//advisory:
				var msg = "startRangeMillis: |" + (new Date(startRangeMillis)) + "|  endRangeMillis: |" + (new Date(endRangeMillis))+ "| localDiscs.length: |" + localDiscs.length + "|  |" + (new Date(localDiscs[0][0])) + "+";

				var filteredDiscs = dataUtil.selectRecordsWithinRangePerDateIndex(localDiscs, 0, startRangeMillis, endRangeMillis);	
				var filteredExecs = dataUtil.selectRecordsWithinRangePerDateIndex(localExecs, 0, startRangeMillis, endRangeMillis);	
				var filteredReinvestments = dataUtil.selectRecordsWithinRangePerDateIndex(localReinvestments, 0, startRangeMillis, endRangeMillis);	
				var filteredTotals = dataUtil.selectRecordsWithinRangePerDateIndex(localTotals, 0, startRangeMillis, endRangeMillis);

				var localSeries = [
					{
						name: 'Total Discretionary',
						data: filteredDiscs
					}, {
						name: 'Total Exclusive',
						data: filteredExecs
					}, {
						name: 'Total Reinvestments',
						data: filteredReinvestments
					}, {
						name: 'Total On Loan',
						data: filteredTotals
					}
				];
				
				currentChart.series = localSeries;
				currentChart.customized.chartName = 'grossEarningsChart'
				
				currentChart.xAxis.tickInterval = vm.grossEarningsChartTickInterval;

				currentChart.title.text = "Gross Earnings"
				
				var Highcharts = require('highcharts');
				Highcharts.chart("grossgraph", currentChart);
			},
			  processScrollBarData: function (event) {

				var scrollBar = event.target;

				var adjustedScrollLeft = event.target.scrollWidth + scrollBar.scrollLeft;
				var msg = "event.target.scrollWidth: |" + event.target.scrollWidth + "| scrollBar.scrollLeft: |" + scrollBar.scrollLeft;
				msg = msg + "|  adjustedScrollLeft: |" + adjustedScrollLeft + "|   scrollBar.parentElement.clientWidth: |" + scrollBar.parentElement.clientWidth + "|";

				var scrollSpan = scrollBar.scrollWidth;
				var leftScrollPoint = scrollBar.scrollLeft;
				if(event.target.scrollWidth - 0){
					leftScrollPoint  = adjustedScrollLeft - 982;
				}

				var leftScrollPercent = leftScrollPoint/scrollSpan;
				
				var thumblength = parseInt(scrollBar.style.width);			
				var rightScrollPoint = leftScrollPoint + thumblength;
				var rightScrollPercent = rightScrollPoint/scrollSpan;
	
				msg = "leftScrollPercent: |" + leftScrollPercent + "| rightScrollPercent: |" +  rightScrollPercent + "|";

  			  var scrollage = {
				  rightScrollPercent: rightScrollPercent,
				  leftScrollPercent : leftScrollPercent
			  }
				  
				return scrollage;
			},
			parseLineData(objList, xFieldName, yFieldName){
				var pointList = []
				objList.forEach(obj=> {
					var pointCoords = []
					var xVal = obj[xFieldName]
					pointCoords.push(xVal)
					var yVal = obj[yFieldName]
					pointCoords.push(yVal)
					pointList.push(pointCoords)
				});
				return pointList
			},
    getHomeData(){
      var vm = this
      vm.loading=true;
      
      HTTP_API.get('/reports/reporthome')
      .then(response => {
        console.log("home response")
        console.log(response)
        vm.psData = response.data.psData
		vm.esData = response.data.esData
		vm.currencyCode = response.data.prefReportingCurr
		vm.lenderId = response.data.lenderId
		vm.resetAllFlag();
		
		vm.getChartsFromPreviousMonth()
      })
      .catch(function (error) {
        console.log(error.response)
        vm.resetAllFlag();
      })
    },
    resetAllFlag() {
      this.loading = false
    },
    psHeaderStyle({row, column, rowIndex, columnIndex}) {
      return { display: 'none'}
    },
    esHeaderStyle({row, column, rowIndex, columnIndex}) {
      return { color: '#44475C', backgroundColor: '#e6e6e6'}
    },
    getChartsFromPreviousMonth(){
		var vm = this;
		var localCurrencyCode = vm.currencyCode;
		var currencySymbol = dataUtil.getCurrencySymbol(localCurrencyCode);

		var Highcharts = require('highcharts');
		require('highcharts/modules/exporting')(Highcharts);

		var effectiveDates = []

		var totalExclusiveEarnings = []
		var totalDiscretionaryEarnings = []
		var totalReinvestmentEarnings = []
		var totalEarnings = []

		var totalOnLoanData = []
		var totalOnLoanMarketValues = []
		var discOnLoanMarketValues = []
		var excOnLoanMarketValues = []

		var startDateStamp =  new Date(Date.now()-24 * 3600 * 1000*31).getTime()

			var lineChartTemplate = {
        chart: {
          backgroundColor: "#FAFAFA",
        },
					customized:{
						chartName: '',
						realEstate: '',
						data: [],
						discOnLoanMarketValues: [],
						parens: ''
					},
      tooltip: {
        shared: true,
        crosshairs: true,
        borderRadius : 8,
        formatter: function () {
        var s = '<b>' + Highcharts.dateFormat('%b %e, %Y', this.x) + '</b>';

        this.points.forEach((point, i)=>{
              s += '<br/> <b style="font-weight: bold;color :'
                  + point.series.color + '">' + point.series.name
                  + ':</b> ' + currencySymbol + '  ' + dataUtil.formatCurrency(point.y);

            });

    			return s;
                }
      },
					navigation: {
						buttonOptions: {
							theme: {
								"stroke-width": 1,
								stroke: "silver",
								r: 0,
								states: {
									hover: {
										fill: "#bada55",
									},
									select: {
										stroke: "#039",
										fill: "#bada55",
									},
								},
							},
						},
					},
					exporting: {
						buttons: {
							contextButton: {
								enabled: true,
							},
							mtdButton: {
								text: "MTD",
								align: "center",
								y: 25,
								x: -100,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {
										var day1 = null;
										var now = null;
										
										/*Get the latest record, determine the month of it, and get all records 
										from the first of that month to that date:
										*/										
										var latestRecord = '';										
										
										if(this.options.customized.chartName == 'grossEarningsChart'){
											latestRecord = dataUtil.getLastRecordForHomeView(vm, 'grossData');	
										} else{
											latestRecord = dataUtil.getLastRecordForHomeView(vm, 'onLoanData');	
										}

										if(latestRecord != null){											
											now = new Date(latestRecord[0]);
											day1 = dataUtil.determineFirstDayOfMonthContainngTimeVal(latestRecord[0]);
																					}										
										var deltaAsPercentOfYear = (now.getTime() - day1.getTime())/31556952000										
										var dataDisplayPercentage = deltaAsPercentOfYear;
										var scrollBarCssStyle = dataUtil.getHomePageScrollBarCssPerDisplayPercentage(dataDisplayPercentage);										

										var onLoanBalanceDiscretionaries = this.options.customized.data['onLoanBalance_totalDiscretionary']
										onLoanBalanceDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceDiscretionaries, 0, day1, now)

										var onLoanBalanceExclusives = this.options.customized.data['onLoanBalance_totalExclusive']
										onLoanBalanceExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceExclusives, 0, day1, now)

										var onLoanBalanceTotals = this.options.customized.data['onLoanBalance_totalOnLoan']
										onLoanBalanceTotals = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceTotals, 0, day1, now)

										var grossEarningsDiscretionaries = this.options.customized.data['grossEarnings_totalDiscretionary']
										grossEarningsDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsDiscretionaries, 0, day1, now)

										var grossEarningsExclusives = this.options.customized.data['grossEarnings_totalExclusive']
										grossEarningsExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsExclusives, 0, day1, now)

										var grossEarningsReinvestments = this.options.customized.data['grossEarnings_totalReinvestment'];
										grossEarningsReinvestments = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsReinvestments, 0, day1, now);

										var grossEarningsTotals = this.options.customized.data['grossEarnings_totalEarnings']
										grossEarningsTotals = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsTotals, 0, day1, now)

										var realEstate = "loangraph";

										var currentTickInterval = 3600 * 1000 * 24 * 1 //daily

										if(this.options.customized.chartName == 'grossEarningsChart'){
											realEstate = "grossgraph";
											vm.grossEarningsChartTickInterval = currentTickInterval;											
											this.options.series[0].data = grossEarningsDiscretionaries;
											this.options.series[1].data = grossEarningsExclusives;
											this.options.series[2].data = grossEarningsReinvestments;
											this.options.series[3].data = grossEarningsTotals;
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;	
											vm.displayGrossEarningsScrollBar = true;	
										} else{
											realEstate = "loangraph";
											vm.totalOnLoanTickInterval = currentTickInterval;
											this.options.series[0].data = onLoanBalanceDiscretionaries
											this.options.series[1].data = onLoanBalanceExclusives
											this.options.series[2].data = onLoanBalanceTotals
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;
											vm.displayLoanBalanceScrollBar = true;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;

										Highcharts.chart(realEstate, this.options);
									} catch (error) {
                    					console.log(error.response)
									}
								},
							},
							oneMonthButton: {
								text: "1m",
								align: "center",
								y: 25,
								x: -50,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {

										var day1 = dateUtil.getCurrentDateMinusDays(31)
										var now = new Date()

										var dataDisplayPercentage = 0.083;
										var scrollBarCssStyle = dataUtil.getHomePageScrollBarCssPerDisplayPercentage(dataDisplayPercentage);

										var onLoanBalanceDiscretionaries = this.options.customized.data['onLoanBalance_totalDiscretionary']
										onLoanBalanceDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceDiscretionaries, 0, day1, now)

										var onLoanBalanceExclusives = this.options.customized.data['onLoanBalance_totalExclusive']
										onLoanBalanceExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceExclusives, 0, day1, now)

										var onLoanBalanceTotals = this.options.customized.data['onLoanBalance_totalOnLoan']
										onLoanBalanceTotals = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceTotals, 0, day1, now)

										var grossEarningsDiscretionaries = this.options.customized.data['grossEarnings_totalDiscretionary']
										grossEarningsDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsDiscretionaries, 0, day1, now)

										var grossEarningsExclusives = this.options.customized.data['grossEarnings_totalExclusive']
										grossEarningsExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsExclusives, 0, day1, now)

										var grossEarningsReinvestments = this.options.customized.data['grossEarnings_totalReinvestment'];
										grossEarningsReinvestments = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsReinvestments, 0, day1, now);

										var grossEarningsTotals = this.options.customized.data['grossEarnings_totalEarnings']
										grossEarningsTotals = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsTotals, 0, day1, now)

										var realEstate = "loangraph";

										var currentTickInterval = 3600 * 1000 * 24 * 7 //weekly

										if(this.options.customized.chartName == 'grossEarningsChart'){
											realEstate = "grossgraph";
											vm.grossEarningsChartTickInterval = currentTickInterval;											
											this.options.series[0].data = grossEarningsDiscretionaries;
											this.options.series[1].data = grossEarningsExclusives;
											this.options.series[2].data = grossEarningsReinvestments;
											this.options.series[3].data = grossEarningsTotals;
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;	
											vm.displayGrossEarningsScrollBar = true;	
										} else{
											realEstate = "loangraph";
											vm.totalOnLoanTickInterval = currentTickInterval;
											this.options.series[0].data = onLoanBalanceDiscretionaries
											this.options.series[1].data = onLoanBalanceExclusives
											this.options.series[2].data = onLoanBalanceTotals
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;
											vm.displayLoanBalanceScrollBar = true;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;

										Highcharts.chart(realEstate, this.options);
									} catch (error) {
					                    console.log(error.response)
									}
								},
							},
							threeMonthButton: {
								text: "3m",
								align: "center",
								y: 25,
								x: 0,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {
										var day1 = dateUtil.getCurrentDateMinusDays(90)
										var now = new Date()

										var dataDisplayPercentage = 0.25;
										var scrollBarCssStyle = dataUtil.getHomePageScrollBarCssPerDisplayPercentage(dataDisplayPercentage);										

										var onLoanBalanceDiscretionaries = this.options.customized.data['onLoanBalance_totalDiscretionary']
										onLoanBalanceDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceDiscretionaries, 0, day1, now)

										var onLoanBalanceExclusives = this.options.customized.data['onLoanBalance_totalExclusive']
										onLoanBalanceExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceExclusives, 0, day1, now)

										var onLoanBalanceTotals = this.options.customized.data['onLoanBalance_totalOnLoan']
										onLoanBalanceTotals = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceTotals, 0, day1, now)

										var grossEarningsDiscretionaries = this.options.customized.data['grossEarnings_totalDiscretionary']
										grossEarningsDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsDiscretionaries, 0, day1, now)

										var grossEarningsExclusives = this.options.customized.data['grossEarnings_totalExclusive']
										grossEarningsExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsExclusives, 0, day1, now)

										var grossEarningsReinvestments = this.options.customized.data['grossEarnings_totalReinvestment'];
										grossEarningsReinvestments = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsReinvestments, 0, day1, now);

										var grossEarningsTotals = this.options.customized.data['grossEarnings_totalEarnings']
										grossEarningsTotals = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsTotals, 0, day1, now)

										var realEstate = "loangraph";

										var currentTickInterval = 3600 * 1000 * 24 * 14 //bi-weekly

										if(this.options.customized.chartName == 'grossEarningsChart'){
											realEstate = "grossgraph";
											vm.grossEarningsChartTickInterval = currentTickInterval;											
											this.options.series[0].data = grossEarningsDiscretionaries;
											this.options.series[1].data = grossEarningsExclusives;
											this.options.series[2].data = grossEarningsReinvestments;
											this.options.series[3].data = grossEarningsTotals;
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;	
											vm.displayGrossEarningsScrollBar = true;	
										} else{
											realEstate = "loangraph";
											vm.totalOnLoanTickInterval = currentTickInterval;
											this.options.series[0].data = onLoanBalanceDiscretionaries
											this.options.series[1].data = onLoanBalanceExclusives
											this.options.series[2].data = onLoanBalanceTotals
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;
											vm.displayLoanBalanceScrollBar = true;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;

										Highcharts.chart(realEstate, this.options);
									} catch (error) {
                    					console.log(error.response)
									}
								},
							},
							sixMonthButton: {
								text: "6m",
								align: "center",
								y: 25,
								x: 50,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {
										var day1 = dateUtil.getCurrentDateMinusDays(120)
										var now = new Date()

										var dataDisplayPercentage = 0.5;
										var scrollBarCssStyle = dataUtil.getHomePageScrollBarCssPerDisplayPercentage(dataDisplayPercentage);										


										var onLoanBalanceDiscretionaries = this.options.customized.data['onLoanBalance_totalDiscretionary']
										onLoanBalanceDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceDiscretionaries, 0, day1, now)

										var onLoanBalanceExclusives = this.options.customized.data['onLoanBalance_totalExclusive']
										onLoanBalanceExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceExclusives, 0, day1, now)

										var onLoanBalanceTotals = this.options.customized.data['onLoanBalance_totalOnLoan']
										onLoanBalanceTotals = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceTotals, 0, day1, now)

										var grossEarningsDiscretionaries = this.options.customized.data['grossEarnings_totalDiscretionary']
										grossEarningsDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsDiscretionaries, 0, day1, now)

										var grossEarningsExclusives = this.options.customized.data['grossEarnings_totalExclusive']
										grossEarningsExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsExclusives, 0, day1, now)

										var grossEarningsReinvestments = this.options.customized.data['grossEarnings_totalReinvestment'];
										grossEarningsReinvestments = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsReinvestments, 0, day1, now);

										var grossEarningsTotals = this.options.customized.data['grossEarnings_totalEarnings']
										grossEarningsTotals = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsTotals, 0, day1, now)

										var realEstate = "loangraph";

										var currentTickInterval = 3600 * 1000 * 24 * 31 //monthly

										if(this.options.customized.chartName == 'grossEarningsChart'){
											realEstate = "grossgraph";
											vm.grossEarningsChartTickInterval = currentTickInterval;											
											this.options.series[0].data = grossEarningsDiscretionaries;
											this.options.series[1].data = grossEarningsExclusives;
											this.options.series[2].data = grossEarningsReinvestments;
											this.options.series[3].data = grossEarningsTotals;
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;	
											vm.displayGrossEarningsScrollBar = true;	
										} else{
											realEstate = "loangraph";
											vm.totalOnLoanTickInterval = currentTickInterval;
											this.options.series[0].data = onLoanBalanceDiscretionaries
											this.options.series[1].data = onLoanBalanceExclusives
											this.options.series[2].data = onLoanBalanceTotals
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;
											vm.displayLoanBalanceScrollBar = true;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;

										Highcharts.chart(realEstate, this.options);
									} catch (error) {
                    					console.log(error.response)
									}
								},
							},
							oneYearButton: {
								text: "1Y",
								align: "center",
								y: 25,
								x: 100,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {

										var day1 = dateUtil.getCurrentDateMinusDays(366)
										var now = new Date()

										var dataDisplayPercentage = 1.1;
										var scrollBarCssStyle = dataUtil.getHomePageScrollBarCssPerDisplayPercentage(dataDisplayPercentage);										


										var onLoanBalanceDiscretionaries = this.options.customized.data['onLoanBalance_totalDiscretionary']
										onLoanBalanceDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceDiscretionaries, 0, day1, now)

										var onLoanBalanceExclusives = this.options.customized.data['onLoanBalance_totalExclusive']
										onLoanBalanceExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceExclusives, 0, day1, now)

										var onLoanBalanceTotals = this.options.customized.data['onLoanBalance_totalOnLoan']
										onLoanBalanceTotals = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceTotals, 0, day1, now)

										var grossEarningsDiscretionaries = this.options.customized.data['grossEarnings_totalDiscretionary']
										grossEarningsDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsDiscretionaries, 0, day1, now)

										var grossEarningsExclusives = this.options.customized.data['grossEarnings_totalExclusive']
										grossEarningsExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsExclusives, 0, day1, now)

										var grossEarningsReinvestments = this.options.customized.data['grossEarnings_totalReinvestment'];
										grossEarningsReinvestments = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsReinvestments, 0, day1, now);

										var grossEarningsTotals = this.options.customized.data['grossEarnings_totalEarnings']
										grossEarningsTotals = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsTotals, 0, day1, now)

										var realEstate = "loangraph";
										
										scrollBarCssStyle = 'width:865px;height:100px';

										var currentTickInterval = 3600 * 1000 * 24 * 31 //monthly

										if(this.options.customized.chartName == 'grossEarningsChart'){
											realEstate = "grossgraph";
											vm.grossEarningsChartTickInterval = currentTickInterval;											
											this.options.series[0].data = grossEarningsDiscretionaries;
											this.options.series[1].data = grossEarningsExclusives;
											this.options.series[2].data = grossEarningsReinvestments;
											this.options.series[3].data = grossEarningsTotals;
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;	
											vm.displayGrossEarningsScrollBar = true;	
										} else{
											realEstate = "loangraph";
											vm.totalOnLoanTickInterval = currentTickInterval;
											this.options.series[0].data = onLoanBalanceDiscretionaries
											this.options.series[1].data = onLoanBalanceExclusives
											this.options.series[2].data = onLoanBalanceTotals
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;
											vm.displayLoanBalanceScrollBar = true;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;

										Highcharts.chart(realEstate, this.options);
									} catch (error) {
                    					console.log(error.response)
									}
								},
							},
							yearToDateButton: {
								text: "YTD",
								align: "center",
								y: 25,
								x: 150,
								symbolFill: "#B5C9DF",
								hoverSymbolFill: "#779ABF",
								_titleKey: "Balance",
								onclick: function () {
									try {

										var day1 = dateUtil.getFirstDayOfThisYear()
										var now = new Date()

										var deltaAsPercentOfYear = (now.getTime() - day1.getTime())/31556952000										
										var dataDisplayPercentage = deltaAsPercentOfYear;
										var scrollBarCssStyle = dataUtil.getHomePageScrollBarCssPerDisplayPercentage(dataDisplayPercentage);										

										var onLoanBalanceDiscretionaries = this.options.customized.data['onLoanBalance_totalDiscretionary']
										onLoanBalanceDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceDiscretionaries, 0, day1, now)

										var onLoanBalanceExclusives = this.options.customized.data['onLoanBalance_totalExclusive']
										onLoanBalanceExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceExclusives, 0, day1, now)

										var onLoanBalanceTotals = this.options.customized.data['onLoanBalance_totalOnLoan']
										onLoanBalanceTotals = dataUtil.selectRecordsWithinRangePerDateIndex(onLoanBalanceTotals, 0, day1, now)

										var grossEarningsDiscretionaries = this.options.customized.data['grossEarnings_totalDiscretionary']
										grossEarningsDiscretionaries = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsDiscretionaries, 0, day1, now)

										var grossEarningsExclusives = this.options.customized.data['grossEarnings_totalExclusive']
										grossEarningsExclusives = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsExclusives, 0, day1, now)

										var grossEarningsReinvestments = this.options.customized.data['grossEarnings_totalReinvestment'];
										grossEarningsReinvestments = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsReinvestments, 0, day1, now);

										var grossEarningsTotals = this.options.customized.data['grossEarnings_totalEarnings']
										grossEarningsTotals = dataUtil.selectRecordsWithinRangePerDateIndex(grossEarningsTotals, 0, day1, now)

										var realEstate = "loangraph";

										var currentTickInterval = 3600 * 1000 * 24 * 31 //monthly

										if(this.options.customized.chartName == 'grossEarningsChart'){
											realEstate = "grossgraph";
											vm.grossEarningsChartTickInterval = currentTickInterval;											
											this.options.series[0].data = grossEarningsDiscretionaries;
											this.options.series[1].data = grossEarningsExclusives;
											this.options.series[2].data = grossEarningsReinvestments;
											this.options.series[3].data = grossEarningsTotals;
											vm.grossEarningsChartOptions = this.options;
											vm.grossEarningsDisplayPercentage = dataDisplayPercentage;
											vm.grossEarningsScrollbarCssStyle = scrollBarCssStyle;	
											vm.displayGrossEarningsScrollBar = true;	
										} else{
											realEstate = "loangraph";
											vm.totalOnLoanTickInterval = currentTickInterval;
											this.options.series[0].data = onLoanBalanceDiscretionaries
											this.options.series[1].data = onLoanBalanceExclusives
											this.options.series[2].data = onLoanBalanceTotals
											vm.onLoanBalanceChartOptions = this.options;
											vm.onLoanBalanceDisplayPercentage = dataDisplayPercentage;
											vm.onLoanBalanceScrollbarCssStyle = scrollBarCssStyle;
											vm.displayLoanBalanceScrollBar = true;
										}

										var currentXAxis =  {
										title: {
											text: this.options.xAxis.title
										},
										type: 'datetime',
										tickInterval: currentTickInterval
										};
										this.options.xAxis = currentXAxis;

										Highcharts.chart(realEstate, this.options);
									} catch (error) {
                    					console.log(error.response)
									}
								}
							},
						},
					},
					title: {
						text: ''
					},
					subtitle: {
						text: ''
					},
					yAxis: {
							title: {
							text: null
							},
							labels: {
								formatter: function () {
									return currencySymbol + " " + dataUtil.formatCurrency(this.value, 0);
								}
							}
						},
					xAxis: {
						title: {
							text: null
						},
						type: 'datetime',
						tickInterval: 3600 * 1000 * 24 * 61 // 2 days
					},
					legend: {
						layout: 'horizontal',
						align: 'center',
						verticalAlign: 'bottom'
					},
					plotOptions: {
						series: {
							label: {
								connectorAllowed: false
							},
							// pointStart: Date.UTC(2010, 0, 1),
							pointStart: startDateStamp,
							pointInterval: 3600 * 1000 * 24 // one day
						}
					},
					series: [],
					responsive: {
						rules: [{
							condition: {
								maxWidth: 500
							},
							chartOptions: {
								legend: {
									layout: 'horizontal',
									align: 'center',
									verticalAlign: 'bottom'
								}
							}
						}]
					},
          credits: {
						enabled: false
					}
			}  //close lineChartTemplate

      var dateBoundXAxis =  {
            type: 'datetime',
            dateTimeLabelFormats: { // don't display the dummy year
                month: '%e. %b',
                year: '%b'
            },
            title: {
                text: 'Date'
            }
        };

      /////// DATE /////////
      var yesterday = new Date();
      yesterday.setDate(this.date.getDate()-1)
      var day = yesterday.getDate();
      if (day < 10){
        day = '0' + day;
      }
      var month = yesterday.getMonth()
      var year = yesterday.getFullYear();
      this.endDateString = day + '-'+ this.months[month] + '-'+ String(year).slice(-2);

      var previousMonth = new Date()
      previousMonth.setDate(this.date.getDate()-32)
       var day2 = previousMonth.getDate();
      if (day2 < 10){
        day2 = '0' + day2;
      }
      var month2 = previousMonth.getMonth()
      var year2 = previousMonth.getFullYear();
      this.startDateString = day2 + '-'+ this.months[month2] + '-'+ String(year2).slice(-2);

      var postBody = {};
      postBody.lenderId = this.lenderId
      postBody.currencyCode = this.currencyCode

	  /*2022_February_9 - Updating the startDate to be 366 days from the current date,
	  to bring the timeframe into line with the enhancement requested via email on
	  January 11, 2022 - Item 1.6 of that email:
	  */
	  var startDateFull = dateUtil.getCurrentDateMinusDays(366)
	  var startDate = dateUtil.toDateString(startDateFull)
	  postBody.startDateString = startDate;

	  //for rollback-as needed: pre-February-9 same-day graph timeline parameter:
	  //postBody.startDateString = this.startDateString;

      postBody.endDateString = this.endDateString;
      
	  GRAPHICS_HTTP_API.post('/hometabchartdata',postBody).then(response => {
      var retVal = response.data

		totalExclusiveEarnings = retVal.totalExclusiveEarnings
		totalExclusiveEarnings = pieChartUtil.parseLineData(totalExclusiveEarnings, 'effectiveDate', 'earningsAmount')
		vm.grossData1 = totalExclusiveEarnings;

		totalReinvestmentEarnings = retVal.totalReinvestmentEarnings
		totalReinvestmentEarnings = pieChartUtil.parseLineData(totalReinvestmentEarnings, 'effectiveDate', 'earningsAmount')
		vm.grossData2 = totalReinvestmentEarnings;

		totalDiscretionaryEarnings = retVal.totalDiscretionaryEarnings
		totalDiscretionaryEarnings = pieChartUtil.parseLineData(totalDiscretionaryEarnings, 'effectiveDate', 'earningsAmount')
		vm.grossData0 = totalDiscretionaryEarnings;

        totalEarnings = retVal.totalEarnings
		totalEarnings = pieChartUtil.parseLineData(totalEarnings, 'effectiveDate', 'earningsAmount')
		vm.grossData3 = totalEarnings;

        totalOnLoanData = retVal.totalOnLoanData

        var dates = []
        discOnLoanMarketValues = pieChartUtil.parseLineData(totalOnLoanData, 'effectiveDate', 'discOnLoanMarketValue');
		vm.onLoanData0 = discOnLoanMarketValues;

        excOnLoanMarketValues = pieChartUtil.parseLineData(totalOnLoanData, 'effectiveDate', 'excOnLoanMarketValue');
		vm.onLoanData1 = excOnLoanMarketValues;

        totalOnLoanMarketValues = pieChartUtil.parseLineData(totalOnLoanData, 'effectiveDate', 'totalOnLoanMarketValue');
		vm.onLoanData2 = totalOnLoanMarketValues;

    		var onLoanBalanceChart = Object.assign({}, lineChartTemplate)
				onLoanBalanceChart.customized.data['onLoanBalance_totalDiscretionary'] = discOnLoanMarketValues
				onLoanBalanceChart.customized.data['onLoanBalance_totalExclusive'] = excOnLoanMarketValues
				onLoanBalanceChart.customized.data['onLoanBalance_totalOnLoan'] = totalOnLoanMarketValues
				onLoanBalanceChart.customized.chartName = 'onLoanBalanceChart'
				onLoanBalanceChart.parent = this

				var totalOnLoanSeries1 = [
					{
						name: 'Total Discretionary',
						data: discOnLoanMarketValues
					}, {
						name: 'Total Exclusive',
						data: excOnLoanMarketValues
					}, {
						name: 'Total On Loan',
						data: totalOnLoanMarketValues
					}
					]

				onLoanBalanceChart.series = totalOnLoanSeries1;
				onLoanBalanceChart.title.text = 'Total On Loan'
				onLoanBalanceChart.title.style = { "fontSize": "13px" ,"font-weight": "bold"}
				onLoanBalanceChart.customized.realEstate = 'loangraph'
				
				vm.onLoanBalanceChart = onLoanBalanceChart;

				Highcharts.chart(onLoanBalanceChart.customized.realEstate, onLoanBalanceChart);

  var grossEarningsSeries = [
        {
          name: 'Total Discretionary',
          seriesCurrency: localCurrencyCode,
          data: totalDiscretionaryEarnings
        }, {
          name: 'Total Exclusive',
          data: totalExclusiveEarnings
        }, {
          name: 'Total Reinvestment',
          data: totalReinvestmentEarnings
        }, {
          name: 'Total Earnings',
          data: totalEarnings
        }
      ]

		var grossEarningsChart = Object.assign({}, lineChartTemplate)

				grossEarningsChart.series = grossEarningsSeries;
				grossEarningsChart.title.text = 'Gross Earnings'
				grossEarningsChart.title.style = { "fontSize": "13px" ,"font-weight": "bold"}
				grossEarningsChart.customized.realEstate = 'grossgraph'

				grossEarningsChart.customized.data['grossEarnings_totalDiscretionary'] = totalDiscretionaryEarnings
				grossEarningsChart.customized.data['grossEarnings_totalExclusive'] = totalExclusiveEarnings
				grossEarningsChart.customized.data['grossEarnings_totalReinvestment'] = totalReinvestmentEarnings
				grossEarningsChart.customized.data['grossEarnings_totalEarnings'] = totalEarnings
				grossEarningsChart.customized.chartName = 'grossEarningsChart'
				grossEarningsChart.parent = this

		grossEarningsChart.series = grossEarningsSeries;

    Highcharts.chart('grossgraph', grossEarningsChart);
		}).catch(function (error) {
        console.log(error.response)
    }).finally(function(){

		var onLoanChart = Object.assign({}, lineChartTemplate)

		var totalOnLoanSeries1 = [
				{
				name: 'Total Discretionary',
				seriesCurrency: localCurrencyCode,
				data: discOnLoanMarketValues
				}, {
				name: 'Total Exclusive',
				data: excOnLoanMarketValues
				}, {
				name: 'Total On Loan',
				data: totalOnLoanMarketValues
				}
			]

      	onLoanChart.series = totalOnLoanSeries1;
      	onLoanChart.title.text = 'Total On Loan'
      	onLoanChart.title.style = { "fontSize": "13px" ,"font-weight": "bold"}
    });

    }
  },
  created() {
   this.getHomeData()
  }
}
</script>

<style scoped>
.main{
  height: 100%
  }

.tableDescription{
  color: #44475C;
  font-weight: bold;
  border-top: 1px solid #7D82A8;
  border-right: 1px solid #7D82A8;
  border-left: 1px solid #7D82A8;
  padding: 3px 3px 3px 6px;
  background-color: #cecece
}

.el-table {
  border: 1px solid #44475C;
  background-color: #FAFAFA;
}

.el-table >>> td {
  border-right: 1px solid #7D82A8;
  border-top: 1px solid #7D82A8;
  padding: 0 0 0 0;
}

.el-table >>> td .cell {
  word-break: normal;
  white-space: nowrap;
  font-size: 12.5px;
  padding-right: 5px;
  padding-left: 5px;
}

.el-table >>> td:last-child {
  border-right: none;
}

.el-table >>> th {
  border-right: 1px solid #7D82A8;
  padding: 0 0 0 0;
}

.el-table >>> th:last-child {
  border-right: none;
}

#loangraph, #grossgraph{
  height: 310px
}
</style>